 /* eslint-disable */
 import service from './coach-import-service';
 import i18n from '@/lang' // Internationalization

export default {
  namespaced: true,

  state: {
    loading: false,
    list: [],
    team : null
  },

  getters: {
    loading: (state) => state.loading,
    list: (state) => state.list,
    pager: (state) => state.pager,
    team: (state) => state.team
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    TEAM(state, payload) {
      state.team = payload;
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.team = null;
    }
  },

  actions: {
    setup({ commit, dispatch, getters }, modelTeam) {
      commit('LOADING', true);
      
      console.log("<--- SETUP PLAYER IMPORT");
      console.log(modelTeam);
      
      if ( modelTeam !== null ) {
        commit('LOADING', false);
        commit('TEAM', modelTeam);
        return Promise.resolve();
      } else {
        commit('LOADING', false);
        var error = new Error('Equipo no existe.')
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      }
    },

    createAllPlayers({ commit, dispatch, getters, rootGetters }, playerList) {
      //commit('LOADING', true);
      console.log("<-- CREATE ALL PLAYERS");
      console.log(playerList);
      
      service
      .createAllPlayers(playerList, rootGetters['auth/user'])
      .then(() => {
        dispatch(
          'shared/success',
          `${i18n.t('entities.player.plural')} ${i18n.t('notification.savedSuccessfully')}`,
          { root: true }
        );

        commit('LOADING', false);
      })
      // .catch((error) => {
      //   commit('LOADING', false);
      //   dispatch('shared/error', error, { root: true });
      //   return Promise.reject(error);
      // });
    },
    
    clear({ commit }) {
      commit('CLEAR');
    }
  }
};



// WEBPACK FOOTER //
// ./src/entities/coach/coach-import/coach-import-store.js